import { useMemo } from 'react';

import { useUser } from 'shared/hooks/user';
import { getShortName } from 'shared/utils/user';

export const useAvatarContent = () => {
  const user = useUser();

  return useMemo(() => (user ? getShortName(user) : ''), [user]);
};
